import * as Sentry from '@sentry/react';
import { Button } from '@/components/ui/button';
import { AlertTriangle } from 'lucide-react';

/**
 * Componente de teste do Sentry
 * 
 * Para ativar, adicione ao arquivo .env:
 * VITE_ENABLE_SENTRY_TEST=true
 * 
 * Depois reinicie o servidor de desenvolvimento.
 */
export function SentryTestButton() {
  // Controle via variável de ambiente
  const isEnabled = import.meta.env.VITE_ENABLE_SENTRY_TEST === 'true';
  
  // Desativado por padrão
  if (!isEnabled) {
    return null;
  }

  // Só mostra em modo desenvolvimento
  if (import.meta.env.PROD) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 z-50">
      <Button
        variant="destructive"
        size="sm"
        onClick={() => {
          console.log('🔴 Botão de teste clicado! Lançando erro de teste para o Sentry...');
          throw new Error('This is your first error!');
        }}
        className="gap-2"
      >
        <AlertTriangle className="h-4 w-4" />
        Break the world (Teste Sentry)
      </Button>
    </div>
  );
}
